import React from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, Table } from "reactstrap";

const LastDataTab = ({ lastData }) => {
  const lang_choiced = useSelector((state) => state.lang_change);

  //   console.log(lastData, "is lastData");
  const checkNullData = (data) => {
    if (data) return data;
    else return "-";
  };
  return (
    <div>
      <Card>
        <CardBody>
          <p>
            {lang_choiced.pages.byPanel.PanelGroup.Line.Modal.lastDataTab.text}
          </p>
          <div style={{ textAlign: "-webkit-center" }}>
            <Table className="w-auto" bordered responsive>
              <tbody>
                <tr>
                  <th scope="row">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.P
                    }
                  </th>
                  <td className="ltr">
                    {checkNullData(
                      lastData && ((lastData?.Vpv * lastData?.Ipv) / 100000).toFixed(2)
                    )}{" "}
                    W
                  </td>
                  <th scope="row">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.Pbat
                    }
                  </th>
                  <td className="ltr">
                    {checkNullData(
                      lastData && ((lastData?.Vbat * lastData?.Ibat) / 100000).toFixed(2)
                    )}{" "}
                    W
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.Pnet
                    }
                  </th>
                  <td className="ltr">
                    {checkNullData(
                      lastData && (
                        (lastData?.Vbat * lastData?.Ibat +
                          lastData?.Vpv * lastData?.Ipv) /
                        100000
                      ).toFixed(2)
                    )}{" "}
                    W
                  </td>
                  <th scope="row">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.V
                    }
                  </th>
                  <td className="ltr">
                    {checkNullData(lastData && (lastData?.Vpv / 100).toFixed(2))} V
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.I
                    }
                  </th>
                  <td className="ltr">
                    {checkNullData(lastData && (lastData?.Ipv / 1000).toFixed(2))} A
                  </td>
                  <th scope="row">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.Vbat
                    }
                  </th>
                  <td className="ltr">
                    {checkNullData(lastData && (lastData?.Vbat / 100).toFixed(2))} V
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.Ibat
                    }
                  </th>
                  <td className="ltr">
                    {checkNullData(lastData && (lastData?.Ibat / 1000).toFixed(2))} A
                  </td>
                  <th scope="row">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.Vo
                    }
                  </th>
                  <td className="ltr">
                    {checkNullData(lastData && (lastData?.Vo / 10).toFixed(1))} V
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.SOC
                    }
                  </th>
                  <td className="ltr">
                    {checkNullData(lastData && lastData?.SOC / 100) > 100
                      ? 100
                      : checkNullData(lastData && (lastData?.SOC / 100).toFixed(0))}{" "}
                    %
                  </td>
                  <th scope="row">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.Temp
                    }
                  </th>
                  <td className="ltr fs-16">
                    {checkNullData(lastData && Math.round(lastData?.Temp / 10) / 10)} ºC
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default LastDataTab;
